export default __webpack_public_path__ + "static/BgCustom-c9bb000f42af4c8ce292192ee1ffb871.webp";